@if (marketTabs?.length && inOverlay) {
    <ms-market-list-header [marketTabs]="marketTabs" (tabClicked)="tabClickedEventHandler($event)" />
}
<ng-scrollbar [sensorDebounce]="5" [autoHeightDisabled]="inOverlay">
    @if (optionGroups) {
        <ms-option-group-list
            [style.margin-bottom.px]="bottomOffset()"
            [optionGroups]="optionGroups"
            [event]="event"
            [sourceOfPick]="sourceOfPick"
            [hideEventCarousel]="true"
            [forceSingleColumn]="inOverlay"
            [tracking]="betBuilderTrackingValues.BetBuilder"
            [defaultExpandedMarketsCount]="defaultExpandedMarketsCount" />

        @if (!optionGroups.length) {
            <ms-error severity="info" [message]="sitecore.betBuilderEntainUI.messages?.NoBettingOffer" />
        }
    }
</ng-scrollbar>
@if (inOverlay) {
    <div class="sgp-overlay-betbar-container">
        @if (isQuickBetActive()) {
            <ng-container *msComponentProxy="quickBetComponent" />
        }
        <ng-container *msComponentProxy="betBarComponent" />
    </div>
}
